// frontend/src/features/tbs/components/JobHistory.jsx
import React from "react";
import { Loader2, CheckCircle2, AlertCircle } from "lucide-react";

function when(iso) {
  if (!iso) return "";
  const d = new Date(iso.endsWith("Z") ? iso : iso + "Z");
  const now = new Date();
  const sameDay = d.toDateString() === now.toDateString();
  return sameDay ? d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" }) : d.toLocaleDateString([], { month: "short", day: "numeric" });
}

function fmtBytes(n) {
  if (!n) return "";
  return n < 1024 * 1024 ? `${Math.round(n / 1024)} KB` : `${(n / (1024 * 1024)).toFixed(1)} MB`;
}

export default function JobHistory({ jobs, activeId, onSelect, onNew }) {
  return (
    <div>
      <div className="tbs-lbl">Recent runs <span className="spacer" />
        {activeId && <button className="tbs-link" onClick={onNew}>+ new run</button>}
      </div>
      {jobs.length === 0 && <p className="tbs-help">Nothing yet. Runs stay here so you can come back for the PDFs or retry the failures.</p>}
      <div className="tbs-hist">
        {jobs.map((j) => {
          const running = j.status === "running" || j.status === "queued";
          return (
            <button key={j.id} className={`tbs-hist-item ${j.id === activeId ? "active" : ""}`} onClick={() => onSelect(j.id)}>
              <span className="t">{j.label || `Run #${j.id}`}</span>
              <span style={{ fontSize: 10, color: "#8E96AD" }}>{when(j.created_at)}</span>
              <span className="m">
                {running ? <Loader2 size={10} className="tbs-spin" /> : j.fail_count ? <AlertCircle size={10} color="#C75454" /> : <CheckCircle2 size={10} color="#2F9E5B" />}
                {j.ok_count}/{j.total} saved{j.fail_count ? ` · ${j.fail_count} failed` : ""}{j.tax_year ? ` · ${j.tax_year}` : ""}{j.bytes_total ? ` · ${fmtBytes(j.bytes_total)}` : ""}
                {j.created_by ? ` · ${String(j.created_by).split("@")[0]}` : ""}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
